import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import ServicesSection from "./components/ServicesSection";
import ProcessSection from "./components/ProcessSection";
import FeaturedProjects from "./components/FeaturedProjects";
import CTASection from "./components/CTASection";
import { Link } from "react-router-dom";
import { useTranslation } from "@/context/TranslationContext";

export default function Home() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-deep-black font-inter">
      <Navbar />
      <main>
        <HeroSection />
        <ServicesSection />
        <ProcessSection />
        <FeaturedProjects />

        {/* Video Section */}
        <section className="py-20 px-4 md:px-12 lg:px-20 bg-dark-panel border-t border-dark-border">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-10">
              <span className="inline-block text-electric-blue text-xs font-semibold uppercase tracking-[0.2em] mb-5 px-3 py-1.5 border border-electric-blue/25 rounded-full bg-electric-blue/5">
                {t("home_video.badge")}
              </span>
              <h2 className="font-black text-white leading-tight mb-4" style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: "clamp(2rem, 4vw, 3rem)" }}>
                {t("home_video.title")}
              </h2>
              <p className="text-silver text-base leading-relaxed max-w-2xl mx-auto">
                {t("home_video.description")}
              </p>
            </div>
            <div className="relative rounded-2xl overflow-hidden border border-dark-border aspect-video">
              <iframe
                src="https://www.youtube.com/embed/I8FCmtznTTI?autoplay=1&mute=1&loop=1&playlist=I8FCmtznTTI&controls=0&showinfo=0&rel=0"
                title="Schemackozo Video"
                className="w-full h-full"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
        </section>

        <CTASection />
        
        {/* Contact CTA */}
        <section className="py-20 px-4 md:px-12 lg:px-20 bg-dark-panel border-t border-dark-border">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl font-black text-white mb-4" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
              {t("home_contact_cta.title")}
            </h2>
            <p className="text-silver text-base mb-8 leading-relaxed">
              {t("home_contact_cta.description")}
            </p>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 bg-electric-blue text-deep-black font-bold px-8 py-3.5 rounded-full hover:shadow-glow-blue transition-all duration-300"
            >
              {t("home_contact_cta.button")}
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
